import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort-asc",
  "use": "sort-asc-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"sort-asc\">\n  <g fill=\"currentColor\" fill-rule=\"nonzero\">\n    <rect width=\"48\" height=\"8\" x=\"8\" y=\"49\" rx=\"1\" />\n    <rect width=\"40\" height=\"8\" x=\"8\" y=\"35\" rx=\"1\" />\n    <rect width=\"28\" height=\"8\" x=\"8\" y=\"21\" rx=\"1\" />\n    <rect width=\"16\" height=\"8\" x=\"8\" y=\"7\" rx=\"1\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol